module.exports = __webpack_public_path__ + "static/img/east.d3df595.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/east.jpg
// module id = 167
// module chunks = 1